import React from 'react';
import { Section } from './ui/Section';
import { BundleCard } from './BundleCard';
import { Timer, ShieldCheck, Lock, Truck, Star } from 'lucide-react';
import { OfferCountdown } from './OfferCountdown';
export function PricingBundles() {
  const productImage = 'https://cdn.magicpatterns.com/uploads/q5pbc7UPXB7yZsJKNiRqwd/LymphoriaX_(6).png';
  const checkoutUrls: Record<number, string> = {
    1: 'https://glowliftessencemx.com/cart/51897747013908:1',
    2: 'https://glowliftessencemx.com/cart/51897747046676:1',
    3: 'https://glowliftessencemx.com/cart/51897747079444:1',
    6: 'https://glowliftessencemx.com/cart/51897747112212:1'
  };
  const bundles = [{
    quantity: 1,
    price: '29,95 €',
    originalPrice: '60 €',
    savings: 50,
    bonuses: [],
    productImage,
    perDayOverride: '1,00'
  }, {
    quantity: 2,
    price: '39,95 €',
    originalPrice: '120 €',
    savings: 67,
    bonuses: [],
    productImage,
    perDayOverride: '0,66'
  }, {
    quantity: 3,
    price: '44,95 €',
    originalPrice: '180 €',
    savings: 75,
    isBestValue: true,
    bonuses: [],
    productImage,
    perDayOverride: '0,50'
  }, {
    quantity: 6,
    price: '64,95 €',
    originalPrice: '360 €',
    savings: 82,
    bonuses: [],
    productImage,
    perDayOverride: '0,36'
  }];
  return <Section id="pricing" className="pt-12" data-id="element-499">
      <div className="text-center mb-10" data-id="element-500">
        <div className="inline-flex items-center gap-2 bg-red-50 text-red-700 px-4 py-2 rounded-full text-sm font-black mb-4 border border-red-100 uppercase tracking-wide" data-id="element-501">
          <Timer className="w-4 h-4" data-id="element-502" />⚡ Oferta por Tiempo Limitado — Precios
          Suben Pronto
        </div>

        <OfferCountdown data-id="element-503" />

        <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-3" data-id="element-504">
          Elige tu Pack y Empieza <span className="text-[#D4AF37]" data-id="element-505">Hoy</span>
        </h2>
        <p className="text-gray-600 text-lg mb-2" data-id="element-506">
          El <strong data-id="element-507">78% de nuestras clientas</strong> eligen el pack de 3 meses
          para resultados óptimos y duraderos.
        </p>
        <p className="text-sm text-red-600 font-bold animate-pulse" data-id="element-508">
          ⚠️ Precio especial activo solo mientras dure el stock
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 items-end mb-10" data-id="element-509">
        {bundles.map((bundle, i) => <BundleCard key={i} {...bundle} onSelect={() => {
        const url = checkoutUrls[bundle.quantity];
        if (url) {
          window.location.href = url;
        }
      }} data-id="element-510" />)}
      </div>

      {/* Trust strip */}
      <div className="bg-[#2D5016] rounded-2xl p-6 grid grid-cols-2 md:grid-cols-4 gap-4 text-center mb-6" data-id="element-511">
        <div className="flex flex-col items-center gap-1.5" data-id="element-512">
          <Truck className="w-6 h-6 text-[#D4AF37]" data-id="element-513" />
          <p className="text-white font-bold text-sm" data-id="element-514">Envío Gratis</p>
          <p className="text-green-300 text-xs" data-id="element-515">A toda España</p>
        </div>
        <div className="flex flex-col items-center gap-1.5" data-id="element-516">
          <ShieldCheck className="w-6 h-6 text-[#D4AF37]" data-id="element-517" />
          <p className="text-white font-bold text-sm" data-id="element-518">Garantía 90 Días</p>
          <p className="text-green-300 text-xs" data-id="element-519">Devolución total</p>
        </div>
        <div className="flex flex-col items-center gap-1.5" data-id="element-520">
          <Lock className="w-6 h-6 text-[#D4AF37]" data-id="element-521" />
          <p className="text-white font-bold text-sm" data-id="element-522">Pago Seguro</p>
          <p className="text-green-300 text-xs" data-id="element-523">SSL 256-bit</p>
        </div>
        <div className="flex flex-col items-center gap-1.5" data-id="element-524">
          <Star className="w-6 h-6 fill-[#D4AF37] text-[#D4AF37]" data-id="element-525" />
          <p className="text-white font-bold text-sm" data-id="element-526">4.9/5 Estrellas</p>
          <p className="text-green-300 text-xs" data-id="element-527">+10.000 reseñas</p>
        </div>
      </div>

      {/* Payment methods */}
      <div className="flex justify-center items-center gap-3 flex-wrap mb-6" data-id="element-528">
        <p className="text-xs text-gray-400 font-medium" data-id="element-529">
          Métodos de pago aceptados:
        </p>
        {['VISA', 'Mastercard', 'Amex', 'PayPal', 'Apple Pay'].map(m => <span key={m} className="bg-gray-100 text-gray-600 text-xs font-bold px-3 py-1.5 rounded-lg border border-gray-200" data-id="element-530">
            {m}
          </span>)}
      </div>

      <div className="text-center" data-id="element-531">
        <p className="text-xs text-gray-400 max-w-2xl mx-auto" data-id="element-532">
          *Los resultados pueden variar de una persona a otra. Este producto no
          está destinado a diagnosticar, tratar, curar o prevenir ninguna
          enfermedad. Complemento a una dieta equilibrada y ejercicio.
        </p>
      </div>
    </Section>;
}